/**
 * @file The Plugin Pair View component.
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { PluginPairService } from '../../plugin-pair.service';
import { AbstractComponent } from '../../../core/helpers/abstract-component';
import { AlertsService } from '../../../core/alerts.service';
var PluginPairViewComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PluginPairViewComponent, _super);
    /**
     * Creates an instance of PluginPairViewComponent.
     * @param {PluginPairService} pluginPairService Used to get the selected function.
     * @param {AlertsService} alertsService Passed to the parent.
     * @memberOf PluginPairViewComponent
     */
    function PluginPairViewComponent(pluginPairService, alertsService) {
        var _this = _super.call(this, alertsService) || this;
        _this.pluginPairService = pluginPairService;
        _this.alertsService = alertsService;
        /**
         * The configuration for the PluginViewShiftsComponent.
         * @type {EntityConfiguration}
         * @memberOf PluginPairViewComponent
         */
        _this.shiftsSource = undefined;
        /**
         * The configuration for the PluginViewControlsComponent.
         * @type {EntityConfiguration}
         * @memberOf PluginPairViewComponent
         */
        _this.controlsSource = undefined;
        return _this;
    }
    /**
     * Retrieves the plugin configurations.
     * @memberOf PluginPairViewComponent
     */
    PluginPairViewComponent.prototype.afterInitialize = function () {
        var pluginViewShiftsComponent = this.configuration.components.find(function (item) { return item.component.indexOf('PluginViewShiftsComponent') !== -1; });
        this.shiftsSource = pluginViewShiftsComponent ? pluginViewShiftsComponent.configuration.data : null;
        var pluginViewControlsComponent = this.configuration.components.find(function (item) { return item.component.indexOf('PluginViewControlsComponent') !== -1; });
        this.controlsSource = pluginViewControlsComponent ? pluginViewControlsComponent.configuration.data : null;
    };
    return PluginPairViewComponent;
}(AbstractComponent));
export { PluginPairViewComponent };
